/**
 * The Provider will update you local data context.
 *
 * @module views/__core/PageDataProvider/PageDataProvider
 */
import React, { useContext, createContext, useState } from 'react';
/**
 * Context context object for react reuse
 * @type object
 */
export const PageDataContext = createContext();

/**
 * updatePageData is a function which calls to update the state of the page
 * @type object
 * @property { Function } setLocalPageData - a method to update local state object
 * returns { Function } - to update state objects loading, data, error
 */
export const updatePageData = function( setLocalPageData ){
  return ( { loading, data, error } )=>{
    setLocalPageData( { loading, data, error } );
  }
}

/**
 * Represents a PageDataProvider component
 *
 * @method
 * @param { Object } props - React properties passed from composition
 * @returns PageDataContext
 */
export const PageDataProvider = function( { children } ){
  const [pageData, setLocalPageData] = useState( { loading:null, data:null, error: null } );
  return (
    <PageDataContext.Provider
      value={ {
        setPageData: updatePageData( setLocalPageData ),
        loading: pageData.loading,
        error: pageData.error,
        data: pageData.data
      } }
    >
      { children }
    </PageDataContext.Provider>
  )
}

export default PageDataProvider;

/**
 * context provider
 * @type object
 */
export const usePageDataContext = () => useContext( PageDataContext );
